import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OrgSettingsService } from '@app/orgs/services/org-settings.service';
import type { OrgSetting } from '@degreed/lxp/org/settings';
import { SettingTileHeaderComponent } from '@degreed/lxp/org/settings';
import {
  SettingTileSaveFooterComponent,
  SettingTileValidationMessageComponent,
} from '@degreed/lxp/org/ui';
import { OrgSettingBase } from '@degreed/lxp/org/utils';
import { TranslateModule } from '@ngx-translate/core';

export interface FormField {
  Key: string;
  Value: string;
}

@Component({
  selector: 'dgx-setting-tile-toggle-json',
  templateUrl: './setting-tile-toggle-json.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    SettingTileHeaderComponent,
    SettingTileSaveFooterComponent,
    SettingTileValidationMessageComponent,
  ],
})
// TODO: refactor away from inheritance — consume OrgSettingBase as a host
// directive / injectable controller once the base is converted.
export class SettingTileToggleJsonComponent extends OrgSettingBase<
  OrgSetting,
  OrgSettingsService
> {
  public formFields: FormField[];
  protected orgSettings = inject(OrgSettingsService);

  public handleSave() {
    this.setting.enabled = this.settingEnabled;
    this.formFields.forEach((field) => {
      field.Value = this.settingForm.get(field.Key).value;
    });
    this.setting.value = JSON.stringify(this.formFields);
    this.settingSaved.emit(this.setting);
    this.settingForm.markAsPristine();
    this.setFocusToForm();
  }

  protected resetFormToDefault() {
    const defaultValues = {} as any;
    this.formFields.forEach((field) => {
      defaultValues[field.Key] = field.Value;
    });
    this.settingForm.reset(defaultValues);
  }

  protected createFormGroupFromSetting() {
    this.formFields = JSON.parse(this.setting.value) as FormField[];
    const group = {} as any;
    this.formFields.forEach((field) => {
      const validators: any[] = [];
      if (this.validationSettings) {
        this.validationSettings.forEach((validation) => {
          if (
            validation.ValidationField === field.Key ||
            !validation.ValidationField
          ) {
            validators.push(this.getValidator(validation));
          }
        });
      }
      group[field.Key] = new FormControl(field.Value, validators);
    });
    return group;
  }
}
